<template>
  <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
    <div class="group">
      <div class="group-header">
        <div class="row">
          <div class="col-12 d-flex"><span style="font-size: 1rem;line-height: 25px;padding-right: 10px;">Tiêu đề:</span>
            <h3 class="mb-0"> {{ detail.title }}</h3>
          </div>
        </div>
        <div class="row" style="padding-top: 5px;">
          <div class="col-12 col-md-3"><strong>Chuyên mục:</strong> {{ detail.category_name }}</div>
          <div class="col-12 col-md-3"><strong>Thời gian đăng:</strong> {{ detail.created_at }}</div>
          <div class="col-12 col-md-3"><strong>Đơn vị làm tin:</strong> {{ detail.unit_code }}</div>
          <div class="col-12 col-md-3"><strong>Tác giả:</strong> {{ detail.alias }}</div>
        </div>
        <div class="row" style="padding-top: 5px;">
          <!-- <div class="col-12 col-md-3"><strong>Lượt tải:</strong> 50</div> -->
          <div class="col-12 col-md-3"><strong>Lượt lấy tin:</strong> {{ detail.article_get }}</div>
          <div class="col-12 col-md-3"><strong>Lượt xem:</strong> {{ detail.views }}</div>
          <div class="col-12 col-md-3">&nbsp;</div>
        </div>
      </div>
    </div>
    <b-tabs class="p-1">
      <b-tab title="Nhật ký" active>
        <div class="row">
          <b-col cols="12">
            <b-table ref="refUserListTable" class="articletype-relative" :items="itemsData" :fields="tableColumns"
              primary-key="id" responsive show-empty empty-text="Không tìm thấy kết quả">
              <template #cell(full_name)="data">
                <div class="d-flex">
                  <span class="pr-1">{{ data.item.full_name }}</span><small class="text-muted">{{ data.item.username
                  }}</small>
                </div>
              </template>
            </b-table>
          </b-col>
          <b-col cols="12" class="d-flex align-items-center justify-content-center">
            <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage" first-number last-number
              class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </div>
      </b-tab>
      <b-tab title="Nội dung" lazy v-html="detail.content"></b-tab>
      <b-tab title="Người xem" lazy>
        <user-view-article :user_ids="user_ids" />
      </b-tab>
    </b-tabs>
  </b-overlay>
</template>
<script>

import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BLink, BFormCheckbox, BOverlay,
  BPagination, BInputGroupAppend, BInputGroup, BFormGroup, BTab, BTabs, BCardText
} from 'bootstrap-vue'
import UserViewArticle from "./UserViewArticle.vue"
import {
  ref, watch, computed,
} from '@vue/composition-api'
import store from '@/store'
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BLink,
    BPagination,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BFormGroup,
    BTab,
    BCardText,
    BTabs,
    BOverlay,
    UserViewArticle
  },
  props: {
    article_id: ''
  },
  setup(props, context) {
    const refListTable = ref(null)
    const detail = ref({})
    const tableColumns = [
      { key: 'full_name', sortable: false, label: 'Người xử lý' },
      { key: 'message', sortable: false, label: 'Nội dung' },
      { key: 'department_name', sortable: false, label: 'Phòng/Ban' },
    ];
    const perPage = ref(10)
    const loading = ref(true)
    const total = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const keyword = ref('')
    const itemsData = ref([]);
    const user_ids = ref([])
    if (props.article_id) {
      const fetchLogView = () => {
        store.dispatch('article/logView', {
          keyword: searchQuery.value,
          page: currentPage.value,
          id: props.article_id,
        })
          .then(response => {
            loading.value = false
            const result = response.data;
            if (result.code === 200) {
              itemsData.value = result.data.data
              detail.value = result.data.detail
              total.value = result.data.total;
              let user_view_ids = result.data.detail.user_list_view.user_ids

              if (user_view_ids.length > 0) {
                user_ids.value = user_view_ids.join(',')

              }
            }
          })
      }
      fetchLogView();
    }
    const dataMeta = computed(() => {
      const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
      return {
        from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: total.value,
      }
    })

    watch([currentPage, perPage, searchQuery], () => {
      refetchData()
    })


    return {
      loading,
      tableColumns,
      perPage,
      currentPage,
      total,
      dataMeta,
      perPageOptions,
      refListTable,
      keyword,
      itemsData,
      detail,
      user_ids
    }
  },

}
</script>
<style lang="scss">
#modalState {
  .modal-dialog {
    max-width: 70% !important;

    .tabs {
      .nav-tabs {
        border-bottom: 1px solid #dae1e7;
        border-radius: 0;

        .nav-link::after {
          background: none !important;
        }

        .active {
          color: #495057;
          background-color: #fff;
          margin-bottom: -1px;
          border: 1px solid transparent;
          border-color: #dee2e6 #dee2e6 #fff;
          border-top-left-radius: 0.25rem;
          border-top-right-radius: 0.25rem;
          font-weight: bold
        }
      }
    }
  }
}

@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>